module.exports = __webpack_public_path__ + "static/media/story-9.65a8f95d.jpg";